export default __webpack_public_path__ + "static/media/scan.738232f5.png";